import axios from 'axios';
import { CORE_API_URL } from '../utility/Constant';

export const getKeywordActions = () => axios.get(`${CORE_API_URL}/keyword_actions`);
